import { createAction, props } from '@ngrx/store';
import { IRule } from '@app/models/rule.model';

enum ActionTypes {
  GetRules = '[RULES] Get Rules',
  RulesLoaded = '[RULES] Load success',
  BeginAddRule = '[RULES] Begin Add Rule',
  BeginRemoveRule = '[RULES] Begin Remove Rule',
  RemoveRule = '[RULES] Remove Rule',
  AddRuleFinished = '[RULES] Add Rule Finished',
  SetSearchText = '[RULES] Set Search Text',
  BeginEditRule = '[RULES] Begin Edit Rule',
  EditRuleSuccess = '[RULES] Edit Rule Success',
  ErrorRules = '[RULES] Error',
}

export const GetRulesAction = createAction(
  ActionTypes.GetRules,
  props<{ payload: { projectTypeId } }>()
);

export const RulesLoadedAction = createAction(
  ActionTypes.RulesLoaded,
  props<{ payload }>()
);

export const BeginAddRuleAction = createAction(
  ActionTypes.BeginAddRule,
  props<{ payload: { rule: any } }>()
);

export const AddRuleFinishedAction = createAction(
  ActionTypes.AddRuleFinished,
  props<{ payload }>()
);

export const BeginEditRuleAction = createAction(
  ActionTypes.BeginEditRule,
  props<{ payload: { rule: any } }>()
);

export const EditRuleSuccessAction = createAction(
  ActionTypes.EditRuleSuccess,
  props<{ payload }>()
);

export const BeginRemoveRuleAction = createAction(
  ActionTypes.BeginRemoveRule,
  props<{ payload: IRule }>()
);

export const RemoveRuleAction = createAction(
  ActionTypes.RemoveRule,
  props<{ payload: IRule }>()
);

export const SetSearchTextAction = createAction(
  ActionTypes.SetSearchText,
  props<{ payload: string }>()
);

export const ErrorRulesAction = createAction(
  ActionTypes.ErrorRules,
  props<Error>()
);
